<div class="glxy-avatar-group-wrapper">
  @for (avatar of shownAvatars(); track avatar; let isFirst = $first) {
    <glxy-avatar
      [src]="avatar.src"
      [width]="avatarWidth()"
      [name]="avatar.name"
      [matTooltip]="avatar.name"
      [class.clickable]="avatar.onClick"
      (click)="avatar.onClick ? avatar.onClick() : null"
      [style.margin-left.px]="isFirst ? null : (avatarWidth() / 4) * -1"
    />
  }

  @if (hasExtraAvatars()) {
    <div
      class="extra-avatar-counter"
      [style.width.px]="avatarWidth()"
      [style.height.px]="avatarWidth()"
      [style.font-size.px]="avatarWidth()"
      [style.margin-left.px]="(avatarWidth() / 4) * -1"
      [matMenuTriggerFor]="menu"
    >
      <span class="count">+{{ extraAvatars().length }}</span>
    </div>
    <mat-menu #menu="matMenu" class="glxy-avatar-group-menu">
      @for (avatar of extraAvatars(); track avatar) {
        <button mat-menu-item [class.clickable]="avatar.onClick" (click)="avatar.onClick ? avatar.onClick() : null">
          <div class="glxy-avatar-group-menu-item">
            <glxy-avatar [src]="avatar.src" [width]="32" [name]="avatar.name" />
            {{ avatar.name }}
          </div>
        </button>
      }
    </mat-menu>
  }
</div>
